import configuration from "../../configuration";
import ODataFulogicsStore from "fulogics-ui-core/dist/api/odata/ODataFulogicsStore";
import {createModel} from "@rematch/core";
import {iRootModel} from "../iRootModel";

export const ForwardStepDestinationLocationsODataEndpoint = `${configuration.API_BASE_URL}/odata/ForwardStepDestinationLocations/Store`;
export const ForwardStepDestinationLocationsStore = ODataFulogicsStore({
        url: ForwardStepDestinationLocationsODataEndpoint,
        key: 'id',
        keyType: 'String',
    });

export type ForwardStepDestinationLocationsState = {}

export const ForwardStepDestinationLocationsModel = createModel<iRootModel>()({
    state: {} as ForwardStepDestinationLocationsState,

    effects: (dispatch) => ({
        
    }),

    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        dxStore() // OrderStepForwardData
        {
            return ForwardStepDestinationLocationsStore;
        }
    }),
})

export default ForwardStepDestinationLocationsModel;